import api from './api';
import { adminApi } from './api';

export const createContactApi = async (payload) => {
  const res = await api.post('/api/v1/contact', payload);
  return res.data;
};

export const getContactsApi = async (params = {}) => {
  const res = await adminApi.get('/api/v1/contact/list', { params });
  return res.data;
};

export const getContactByIdApi = async (contactId) => {
  const res = await adminApi.get(`/api/v1/contact/${contactId}`);
  return res.data;
};

export const updateContactApi = async (contactId, payload) => {
  const res = await adminApi.put(`/api/v1/contact/${contactId}`, payload);
  return res.data;
};

export const deleteContactApi = async (contactId) => {
  const res = await adminApi.delete(`/api/v1/contact/${contactId}`);
  return res.data;
};